import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCall } from "@/lib/api";

export type TFAStatus = {
  enabled: boolean;
  enabled_at: string | null;
};

export type TFAEnrollResponse = {
  secret: string;
  otpauth_url: string;
  qr_png_base64: string;
};

export type TFAVerifyResponse = {
  message: string;
  backup_codes: string[];
};

const KEY = "seguridad";

export function useTFAStatus() {
  return useQuery({
    queryKey: [KEY, "tfa-status"],
    queryFn: () => apiCall<TFAStatus>("get", "/auth/2fa/status"),
  });
}

export function useEnroll2FA() {
  return useMutation({
    mutationFn: () => apiCall<TFAEnrollResponse>("post", "/auth/2fa/enroll", { json: {} }),
  });
}

export function useVerify2FA() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) =>
      apiCall<TFAVerifyResponse>("post", "/auth/2fa/verify", { json: { code } }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEY] });
    },
  });
}

export function useDisable2FA() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) =>
      apiCall<{ message: string }>("post", "/auth/2fa/disable", { json: { code } }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [KEY] });
    },
  });
}
